module.exports = __webpack_public_path__ + "static/media/APP_LifeSaver_152x174_5.75d277cb.png";